import { FiltersSideBarContainerProps } from '@components/filters/v2/tours/FiltersSideBarContainer';
import { useFeatureIsOn } from '@model/ab-testing/service/ab-testing-api';
import { GrowthBookFeatures } from '@model/ab-testing/features';
import { FiltersContainer } from '@styles/search-layout';
import React from 'react';

interface UseFiltersLayoutProps {
  condition: boolean;
  FiltersComponent: React.ComponentType<FiltersSideBarContainerProps>;
}

export const useFiltersLayout = ({ condition, FiltersComponent }: UseFiltersLayoutProps) => {
  const filtersLeftFeature: string = GrowthBookFeatures.FILTERS_LEFT;
  const filtersLeftFeatureEnabled = useFeatureIsOn(filtersLeftFeature);

  const filterComponent = <FiltersContainer>{condition && <FiltersComponent />}</FiltersContainer>;

  const renderLeftFilters = () => (filtersLeftFeatureEnabled ? filterComponent : null);
  const renderRightFilters = () => (!filtersLeftFeatureEnabled ? filterComponent : null);

  return {
    filtersLeftFeatureEnabled,
    renderLeftFilters,
    renderRightFilters
  };
};
